import React, { Component } from 'react';
import './Coordinates.css';
import $ from 'jquery';

import { Route } from 'react-router-dom';

import { app } from '../../base';
import Success from '../Success/Success';

let streetTheganaLatitude = "";
let streetTheganaLongitude = "";
let panorama = "";
let panoHeading = "";
let panoPitch = "";
let imageURL = "";
let inputAddress = "";


let db = app.database();
class Coordinates extends Component {

    state = {
        pictureTaken: false,
        modalIsOpen: false
    }

    componentDidMount() {
        window.initialize = this.initialize;
    }

    initialize() {
        let theganaLatitude = "";
        let theganaLongitude = "";
        if (navigator.geolocation) {
            let options = {
                enableHighAccuracy: true,
                maximumAge: 600000, timeout: 5000
            }
            navigator.geolocation.getCurrentPosition(position => {
                theganaLatitude = position.coords.latitude;
                theganaLongitude = position.coords.longitude;
                let values = "";
                $.get('https://roads.googleapis.com/v1/snapToRoads', {
                    key: "AIzaSyAQ1krD63ufWzBQAATKmIRKBaDPOlXZfks",
                    path: theganaLatitude + ',' + theganaLongitude + '|' + theganaLatitude + ',' + theganaLongitude
                }, function (data) {
                    values = new window.google.maps.LatLng(
                        data.snappedPoints[0].location.latitude,
                        data.snappedPoints[0].location.longitude
                    );
                }).then(function () {
                    values = values.toString();
                    streetTheganaLatitude = values.substring(1, values.indexOf(','));
                    streetTheganaLongitude = values.substring(values.indexOf(', ') + 2, values.length - 1);
                    const fenway = { lat: Number(streetTheganaLatitude), lng: Number(streetTheganaLongitude) };
                    const map = new window.google.maps.Map(document.getElementById("map"), {
                        center: fenway,
                        zoom: 14,
                    });

                    let geocoder = new window.google.maps.Geocoder();
                    let latLngObj = {
                        lat: theganaLatitude,
                        lng: theganaLongitude
                    };
                    geocoder.geocode({ location: latLngObj }, (results) => {
                        if (results[0]) {
                            inputAddress = results[0].formatted_address;
                        }
                    });

                    panorama = new window.google.maps.StreetViewPanorama(
                        document.getElementById("pano"),
                        {
                            position: fenway,
                            pov: {
                                heading: 34,
                                pitch: 10,
                            },
                        }
                    );
                    map.setStreetView(panorama);
                }).then(function () {
                    panoHeading = panorama.getPov().heading;
                    panoPitch = panorama.getPov().pitch;
                    panorama.addListener("position_changed", () => {
                        streetTheganaLatitude = Number(panorama.getPosition().toString().substring(1, panorama.getPosition().toString().indexOf(',') - 1));
                        streetTheganaLongitude = Number(panorama.getPosition().toString().substring(panorama.getPosition().toString().indexOf(',') + 2, panorama.getPosition().toString().length - 1));
                        imageURL = "https://maps.googleapis.com/maps/api/streetview?size=200x250&location=" + streetTheganaLatitude + "," + streetTheganaLongitude + "&fov=80&heading=" + panoHeading + "&pitch=" + panoPitch + "&key=AIzaSyAQ1krD63ufWzBQAATKmIRKBaDPOlXZfks";
                    });
                    panorama.addListener("pov_changed", () => {
                        panoHeading = panorama.getPov().heading;
                        panoPitch = panorama.getPov().pitch;
                        imageURL = "https://maps.googleapis.com/maps/api/streetview?size=200x250&location=" + streetTheganaLatitude + "," + streetTheganaLongitude + "&fov=80&heading=" + panoHeading + "&pitch=" + panoPitch + "&key=AIzaSyAQ1krD63ufWzBQAATKmIRKBaDPOlXZfks";
                    });
                });
            }, function () {
                //do nothing on error
            }, options);
        } else {
            //do nothing for now
        }
    }

    pictureTaken() {
        this.setState({ pictureTaken: true });
    }
    uploadImage() {
        db.ref('info').set({
            addressLine: inputAddress,
            lat: streetTheganaLatitude,
            lng: streetTheganaLongitude,
            imageURL: imageURL
        });
    }

    render() {
        return (
            <div>
                <div id="map"></div>
                <div id="pano"></div>
                <div className="frame">
                </div>
                <button className="takePic" onClick={() => this.pictureTaken()}>Save picture of your location</button>
                <br />
                {
                    this.state.pictureTaken ?
                        <div className="imgResult">
                            <img src={imageURL} className="takenPic" alt="Street View Static" />
                            <div>
                                <h3>Vendor will receive the following information:</h3>
                                <p>Latitude: {streetTheganaLatitude}</p>
                                <p>Longitude: {streetTheganaLongitude}</p>
                                <p>Image of your drop off location.</p>
                                <p><a href="/success"><button className="addLocation" onClick={() => this.uploadImage()}> <b>Approve</b></button></a></p>
                            </div>
                        </div> : null
                }
                <Route path="/success" exact component={Success} />
            </div >
        );
    }
}


export default Coordinates;
